import { browserCondition } from './segment-technologies/browser-condition.value';
import { customerVariableCondition } from './segment-common/custom-variable-condition.value';
import { eventStreamClickCondition } from './segment-behaviors/event-stream-click-condition.value';
import { exitPageCondition } from './segment-behaviors/exit-page-condition.value';
import { geographicAreaCondition } from './segment-common/geographic-area-condition.value';
import { goalCondition } from './segment-behaviors/goal-condition.value';
import { isReturningCondition } from './segment-common/is-returning-condition.value';
import { landingPathCondition } from './segment-behaviors/landing-path-condition.value';
import { languageCondition } from './segment-common/language-condition.value';
import { numberPageviewsCondition } from './segment-behaviors/number-pageviews-condition.value';
import { numberVisitsCondition } from './segment-common/number-visits-condition.value';
import { osVersionCondition } from './segment-technologies/os-version-condition.value';
import { pageViewedCondition } from './segment-behaviors/page-viewed-condition.value';
import { referrerCondition } from './segment-common/referrer-condition.value';
import { resolutionCondition } from './segment-technologies/resolution-condition.value';
import { transactionCondition } from './segment-behaviors/transaction-condition.value';
import { visitDurationCondition } from './segment-behaviors/visit-duration-condition.value';
import { textSeenCondition } from './segment-common/text-seen-condition.value';
import { errorCondition } from './segment-common/error-condition.value';
export const webSegmentConditions = [
    browserCondition,
    resolutionCondition,
    customerVariableCondition,
    eventStreamClickCondition,
    exitPageCondition,
    geographicAreaCondition,
    goalCondition,
    isReturningCondition,
    languageCondition,
    landingPathCondition,
    numberVisitsCondition,
    numberPageviewsCondition,
    osVersionCondition,
    pageViewedCondition,
    referrerCondition,
    transactionCondition,
    textSeenCondition,
    visitDurationCondition,
    errorCondition,
];
//# sourceMappingURL=index.js.map